/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 20,
    height: 19,
    viewBox: '0 0 20 19',
    data: '<g stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round"><path pid="0" _stroke="#234357" stroke-linejoin="round" d="M7.375 17.591V9.732L1 1h17.465L12.09 9.732v4.715"/><path pid="1" d="M9.557 16.544l.688-.688" _stroke="#008AFF" stroke-linejoin="bevel"/></g>'
  }
})
